import { createAction, props } from '@ngrx/store';
import { SystemEntity } from '@wdx/clmi/clmi-swagger-gen';

export const toggleFavourite = createAction(
    '[Favourites] Toggle Favourite',
    props<{
        id: string;
        entity: SystemEntity;
        newValue: boolean;
        reload?: boolean;
    }>(),
);

export const favourite = createAction(
    '[Favourites] Favourite',
    props<{
        id: string;
        entity: SystemEntity;
        reload?: boolean;
    }>(),
);

export const favouriteSuccess = createAction(
    '[Favourites] Favourite Success',
    props<{
        id: string;
        entity: SystemEntity;
        reload?: boolean;
    }>(),
);

export const favouriteFailure = createAction(
    '[Favourites] Favourite Failure',
    props<{
        id: string;
        entity: SystemEntity;
        error: Error;
    }>(),
);

export const unfavourite = createAction(
    '[Favourites] Unfavourite',
    props<{
        entity: SystemEntity;
        id: string;
        reload?: boolean;
    }>(),
);

export const unfavouriteSuccess = createAction(
    '[Favourites] Unfavourite Success',
    props<{
        id: string;
        entity: SystemEntity;
        reload?: boolean;
    }>(),
);

export const unfavouriteFailure = createAction(
    '[Favourites] Unfavourite Failure',
    props<{
        id: string;
        entity: SystemEntity;
        error: Error;
    }>(),
);
